module.exports = __webpack_public_path__ + "static/img/7.2126f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/7.png
// module id = y4L6
// module chunks = 13